/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Sbxtenantuserid3Inputs */

const en_entity_sbxtenantuserid3 = /** @type {(inputs: Entity_Sbxtenantuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SBX Tenant User ID`)
};

const de_entity_sbxtenantuserid3 = /** @type {(inputs: Entity_Sbxtenantuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SBX Mandanten-Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "SBX Tenant User ID" |
*
* @param {Entity_Sbxtenantuserid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_sbxtenantuserid3 = /** @type {((inputs?: Entity_Sbxtenantuserid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Sbxtenantuserid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_sbxtenantuserid3(inputs)
	return de_entity_sbxtenantuserid3(inputs)
});
export { entity_sbxtenantuserid3 as "entity_sbxTenantUserId" }